angular.module("leanlaw").controller("ConfirmModalController", ["$scope", "details", "close", function ($scope, details, close) {
  $scope.details = details;
  $scope.confirm = function () {
    close(true);
  };
  $scope.reject = function () {
    close(false);
  };
  // Close button action can be assigned to a specific response
  $scope.handleCloseButton = function () {
    close($scope.details.ambiguousAnswer || false);
  };
}]);